import React from 'react';
import {ButtonBase} from '@material-ui/core';

export default (props) => {
  const {
    id,
    disabled,
    children,
    className,
    component,
    ...rest
  } = props;

  return (
    <ButtonBase
      id={id}
      className={className}
      component={component || 'button'}
      disabled={disabled}

      {...rest}
    >
      {children}
    </ButtonBase>
  )
};
